import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import WelcomeVideo from '../../welcomeVideo/welcomeVideo'
import './ModuleButton.scss'

function ModuleButton({
	bouncing,
	className,
	moduleBackground,
	moduleDestiny,
	moduleImage,
	moduleTitle,
	moduleWelcomeVideo,
	previousModuleCompleted,
	daysCompleted,
	totalDays,
	notStarted,
	complete,
	inProgress,
	module,
	teacher,
}) {
	const [displayWelcome, setDisplayWelcome] = useState(false)
	const [welcome, setWelcome] = useState('')
	const navigate = useNavigate()

	const openWelcome = (moduleWelcomeVideo, moduleBackground, moduleDestiny) => {
		setWelcome(
			<WelcomeVideo
				welComeVideo={moduleWelcomeVideo}
				background={moduleBackground}
				destiny={moduleDestiny}
				closeWelcome={setDisplayWelcome}
			/>
		)
		setDisplayWelcome(true)
	}

	const handleModuleClick = () => {
		if ((module.step_completed === 'notstarted' && module.day_completed <= 0) ||  module.day_completed === null) {
			if(teacher){
				navigate(moduleDestiny)
			}
			else{
				openWelcome(moduleWelcomeVideo, moduleBackground, moduleDestiny)
			}
			return
		}
		navigate(moduleDestiny)
	}

	return (
		<>
			<button
				className={`${className} ${
					previousModuleCompleted ? 'started' : undefined
				} module-btn`}
				disabled={!previousModuleCompleted}
				onClick={handleModuleClick}
			>
				<img
					className={bouncing ? 'bounce' : undefined}
					src={moduleImage}
					alt={`${moduleTitle} module`}
				/>
				<main>
					<h3>{moduleTitle}</h3>
					{totalDays === daysCompleted ? (
						<h5
							className={
								previousModuleCompleted && complete ? 'show' : 'remove'
							}
						>
							Review
						</h5>
					) : (
						<h5
							className={
								daysCompleted !== null ? 'show' : 'remove'
							}
						>
							{moduleTitle === 'Eye Contact' || moduleTitle === 'Listening' || moduleTitle === 'Facial Expressions' || moduleTitle === 'Posture' || moduleTitle === 'Distance' ?
							`${daysCompleted} of ${totalDays} days`
							:
							`${daysCompleted} of 8 days`}
						</h5>
					)}
				</main>
			</button>
			{displayWelcome && welcome}
		</>
	)
}

export default ModuleButton
